
import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import Spinner from "../../../components/Spinner";
import { listResource, listSponsor } from "../../../http/auth";
import ResourcesTable from "./ResourcesTable";


export default function Resources() {
    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [page, setPage] = useState(1);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0)
    const [nextId, setNextId] = useState("");

    const columns = [
        { id: "sr", label: "Sl. No.", minWidth: 40 },
        { id: "title", label: "Title", minWidth: 140, sortable: true },
        { id: "action", label: "Action", minWidth: 60 },
    ];

    useEffect(() => {
        getResourceList()
    }, [])

    const getResourceList = async (pageArg) => {
        try {
            setLoading(true)
            const pg = pageArg ? pageArg : page
            const res = await listResource(pg)
            const resources = res?.data?.data?.resource
            if (resources) updateRows(resources, pg)
            setTotalCount(res.data?.data?.totalResource)
            setLoading(false)
        } catch (err) {
            setLoading(false)
            // dispatch(showToast({ color: "error", msg: "Something went wrong" }));
        }
    }


    function createData(sr, description, image, link, id, action) {
        return { sr, description, image, link, id, action };
    }

    const updateRows = (resources, pageArg) => {
        const list = resources.map((item, index) => {
            return createData(
                ((pageArg - 1) * 10 + 1) + index + 1,
                item.description || "",
                item.image,
                item.link,
                item._id,
                "-",
            );
        });
        const updatedList = nextId ? [...rows, ...list] : list;
        console.log(updatedList)
        setRows(updatedList);
    };

    const onNextClick = async () => {
        setPage(page + 1);
        getResourceList(page + 1)
    };

    const onPrevClick = async () => {
        setPage(page - 1);
        getResourceList(page - 1)
    };

    return (
        <Paper
            sx={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                boxShadow: "none",
            }}
        >
            <>
                {!loading ? (
                    <ResourcesTable
                        smScreen={smScreen}
                        columns={columns}
                        rows={rows}
                        page={page}
                        setPage={setPage}
                        nextId={nextId}
                        rowsPerPage={10}
                        setLoading={setLoading}
                        onPrevClick={onPrevClick}
                        onNextClick={onNextClick}
                        totalCount={totalCount}
                        getResourceList={getResourceList}
                    />
                ) : (
                    <Spinner />
                )}
            </>
        </Paper>
    );
}


